import React from 'react';
import PropTypes from 'prop-types';
import {
  BOAT_TYPES,
  getCrewCompletionStatus,
  getSidePreferenceForBoatType,
} from '../../utils/boatTypes';

const CrewCard = ({ crew, isSelected, onSelect, onEdit, onDelete, canEdit = true }) => {
  const status = getCrewCompletionStatus(crew);

  // Check if rigging config is required but missing
  const sidePreference = getSidePreferenceForBoatType(crew.boat_type);
  const needsRiggingConfig = sidePreference?.isStrict && !crew.rigging_config;

  return (
    <div
      className={`
                cursor-pointer rounded-lg border p-4 transition-all duration-200 hover:shadow-md
                ${isSelected ? 'border-blue-500 bg-blue-50 shadow-md' : 'border-gray-200 bg-white hover:border-gray-300'}
                ${
                  status === 'complete'
                    ? 'border-l-4 border-l-green-500'
                    : status === 'partial'
                      ? 'border-l-4 border-l-yellow-500'
                      : 'border-l-4 border-l-red-500'
                }
            `}
      onClick={() => onSelect(crew)}
    >
      <div className="mb-3 flex items-start justify-between">
        <h3 className="text-lg font-semibold text-gray-900">{crew.name}</h3>
        <div className="flex items-center space-x-1">
          {canEdit && (
            <button
              className="rounded p-1 text-gray-500 transition-colors hover:bg-blue-100 hover:text-blue-600"
              onClick={(e) => {
                e.stopPropagation();
                onEdit(crew);
              }}
              title="Edit Crew"
            >
              ✏️
            </button>
          )}
          {canEdit && (
            <button
              className="rounded p-1 text-gray-500 transition-colors hover:bg-red-100 hover:text-red-600"
              onClick={(e) => {
                e.stopPropagation();
                onDelete(crew.id);
              }}
              title="Delete Crew"
            >
              🗑️
            </button>
          )}
        </div>
      </div>

      <div className="mb-2 flex flex-wrap items-center gap-2">
        <span className="rounded bg-gray-100 px-2 py-1 text-sm text-gray-600">
          {BOAT_TYPES[crew.boat_type]?.name || crew.boat_type}
        </span>
        <span className="text-sm text-gray-600">
          {crew.member_count || crew.members?.length || 0} members
        </span>
        {crew.is_experimental && (
          <span className="rounded-full bg-purple-100 px-2 py-1 text-xs text-purple-800">
            Experimental
          </span>
        )}
        {needsRiggingConfig && (
          <span
            className="rounded-full bg-amber-100 px-2 py-1 text-xs text-amber-800"
            title="Rigging configuration is required for sweep boats"
          >
            ⚠️ Rigging Required
          </span>
        )}
      </div>

      {crew.description && <div className="mt-2 text-sm text-gray-500">{crew.description}</div>}
    </div>
  );
};

CrewCard.propTypes = {
  crew: PropTypes.object.isRequired,
  isSelected: PropTypes.bool.isRequired,
  onSelect: PropTypes.func.isRequired,
  onEdit: PropTypes.func.isRequired,
  onDelete: PropTypes.func.isRequired,
};

export default CrewCard;
